import {Frame} from "../Components/Shared/Frame";
import {Contribution} from "../Components/Home/Contribution";

export const Home = () => {
  // console.log("Home")
  
  return(
    <Frame><Contribution /></Frame>

    )
  };